import { motion } from "framer-motion";

const CTA_IMG =
  "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBzbWlsaW5nJTIwaG9tZXxlbnwwfHx8fDE3NzgzNTczMzV8MA&ixlib=rb-4.1.0&q=85";

export default function CallToAction() {
  return (
    <section className="py-16 md:py-24" data-testid="cta-section">
      <div className="container-pad mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[2.5rem] overflow-hidden"
        >
          <img src={CTA_IMG} alt="Caregiver and client sharing a comforting moment" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F2942]/85 via-[#0F2942]/65 to-[#0F2942]/30" />
          <div className="relative z-10 px-8 md:px-16 py-20 md:py-28 max-w-2xl text-[#F8FAFC]">
            <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#2A9D8F] mb-5">
              Take the next step
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]" data-testid="cta-heading">
              Your loved ones deserve exceptional care.
            </h2>
            <p className="mt-5 text-base md:text-lg text-[#F8FAFC]/85 leading-relaxed">
              A free 20-minute consultation is the easiest way to start. No
              pressure, no commitment, just a clear path forward.
            </p>
            <a
              href="#booking"
              className="mt-8 inline-flex items-center justify-center rounded-full bg-[#F8FAFC] text-[#0F2942] hover:bg-[#DCEAF2] px-8 py-4 text-sm md:text-base font-medium transition-colors"
              data-testid="cta-get-started"
            >
              Get Started Today
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
